import { Skeleton } from "@/components/ui/skeleton";

interface PageSkeletonProps {
  fullscreen?: boolean;
}

export default function PageSkeleton({ fullscreen = false }: PageSkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Loading page"
      className={
        fullscreen
          ? "min-h-[100dvh] w-full px-6 py-12 animate-fade-in"
          : "min-h-[calc(100dvh-4rem)] w-full pt-32 pb-24 px-6 animate-fade-in"
      }
    >
      <div className="container mx-auto max-w-6xl" aria-hidden="true">
        <div className="mb-16 space-y-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-9 w-3/4 max-w-xl" />
          <Skeleton className="h-9 w-1/2 max-w-md" />
          <Skeleton className="h-4 w-full max-w-2xl mt-4" />
          <Skeleton className="h-4 w-2/3 max-w-xl" />
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="rounded-xl border border-border bg-card p-6 space-y-4"
            >
              <div className="flex items-start justify-between">
                <Skeleton className="h-5 w-2/3" />
                <Skeleton className="h-4 w-8" />
              </div>
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <div className="flex gap-2 pt-2">
                <Skeleton className="h-5 w-14 rounded-md" />
                <Skeleton className="h-5 w-16 rounded-md" />
                <Skeleton className="h-5 w-12 rounded-md" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <span className="sr-only">Loading page</span>
    </div>
  );
}
